<template>
  <div class="container button">
    <input
      :id="id"
      type="button"
      :disabled="isDisabled"
      @click="validate"
      :value="label"
    />
  </div>
</template>

<script>
export default {
  name: "SalesButton",
  props: {
    label: String,
    id: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDisabled() {
      return this.disabled === true;
    }
  },
  methods: {
    validate() {
      // Busco el form que lo envuelve (si existe)
      let elem = this.$parent;
      while (elem && !elem.validate) {
        elem = elem.$parent;
      }

      let valid = false;
      if (elem) {
        valid = elem.validate();
      }

      if (valid) {
        this.$emit("click");
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
div.container {
  padding: 0;
  margin: auto;
  display: inline-block;
  width: 100%;
}
input {
  height: 56px;
  border-radius: 1px;
  color: white;
  background-color: #1973b8;
  border: none;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: center;
  width: 100%;
  padding: 0 30px !important;
  min-width: 128px;
  cursor: pointer;
  transition: all 0.4s ease-out;
}

input[disabled] {
  background-color: #e9e9e9;
  color: #bdbdbd;
}
</style>
